import * as React from 'react';

export interface MoneyProps {
  value: number | undefined;
  currency?: string;
  hideSymbol?: boolean;
}
export const Money: React.SFC<MoneyProps> = props => {
  if (props.value === undefined) {
    return <span />;
  }
  const isNegative = props.value < 0;
  let formatted = Math.abs(props.value).toLocaleString(undefined, {
    style: 'currency',
    currency: props.currency ? props.currency : 'USD',
  });
  if (props.hideSymbol) {
    formatted = formatted.substring(1);
  }
  if (isNegative) {
    return <span className="negative">({formatted})</span>;
  }
  return <span>{formatted}</span>;
};



// WEBPACK FOOTER //
// ./src/common/components/Money.tsx